// extracted by mini-css-extract-plugin
export default {"success":"style_success__er7xb","doneIcon":"style_doneIcon__LdnXC"};